import vmClient from '../../services/vmClient';
import { IExternalAssociation } from '../../types/entity';
import { Course } from './Course';

export const CategoryCourses: IExternalAssociation = vmClient.defineExternalAssociation({
  typeName: 'CategoryCourses',
  associationType: Course,
});
